module.exports = __webpack_public_path__ + "assets/fire-icon.b0fc89cf.svg";